import { useSelector } from 'react-redux';
import Themes from '../../theme/myindex';
const useTheme = () => {
  let { themeType = '' } = useSelector((state: any) => state.setting);
  return Themes[themeType];
};
export default useTheme;
